import { destinationNameToUrlTransform } from 'lib/string/removeSpaceUtils'

function splitCanonicalSegments(canonicalName?: string): Array<string> {
  if (!canonicalName) {
    return []
  }

  return canonicalName
    .split(',')
    .map(segment => segment.trim())
    .filter(Boolean)
}

export function getDestinationSearchCanonicalPath(place?: App.Place | null): string | undefined {
  const canonicalSegments = splitCanonicalSegments(place?.canonicalName)

  if (!canonicalSegments.length) {
    return undefined
  }

  if (canonicalSegments.length === 1) {
    const countrySlug = destinationNameToUrlTransform(canonicalSegments[0])
    return countrySlug ? `/hotels/country/${countrySlug}` : undefined
  }

  const locationSlug = destinationNameToUrlTransform(canonicalSegments.join(', '))
  return locationSlug ? `/hotels/location/${locationSlug}` : undefined
}
